import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05b56528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "it__t" }
const _hoisted_2 = {
  key: 0,
  class: "it__t-head"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "it__t-head" }, " Канал ", -1))
const _hoisted_4 = { class: "it__t-head" }
const _hoisted_5 = { class: "it__t-head" }
const _hoisted_6 = { class: "it__t-head" }
const _hoisted_7 = { class: "it__t-head" }
const _hoisted_8 = {
  key: 1,
  class: "it__t-head"
}
const _hoisted_9 = {
  key: 2,
  class: "it__t-head"
}
const _hoisted_10 = {
  key: 0,
  class: "it__t-body"
}
const _hoisted_11 = { class: "it__t-body" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "it__t-body" }
const _hoisted_14 = { class: "it__t-body" }
const _hoisted_15 = { class: "it__t-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiDropdownFilter = _resolveComponent("UiDropdownFilter")!
  const _component_UiInputFilter = _resolveComponent("UiInputFilter")!
  const _component_UiStatusIndicator = _resolveComponent("UiStatusIndicator")!

  return (_openBlock(), _createElementBlock("div", {
    class: "it",
    style: _normalizeStyle(
			_ctx.isShowPartner
				? `--table-cols:
						minmax(150px, 1fr)
						minmax(120px, 0.7fr)
						minmax(130px, 1fr)
						minmax(450px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr);`
				: `--table-cols:
						minmax(120px, 0.7fr)
						minmax(130px, 1fr)
						minmax(450px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr);`
		)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isShowPartner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_UiDropdownFilter, {
              label: "Партнёр",
              items: _ctx.items.partners,
              onFilter: _ctx.onPartnerFilter
            }, null, 8, ["items", "onFilter"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UiInputFilter, {
          label: "Номер",
          onFilter: _ctx.onInstanceFilter
        }, null, 8, ["onFilter"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_UiInputFilter, {
          label: "Токен",
          onFilter: _ctx.onTokenFilter
        }, null, 8, ["onFilter"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_UiInputFilter, {
          label: "Телефон",
          onFilter: _ctx.onPhoneFilter
        }, null, 8, ["onFilter"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_UiDropdownFilter, {
          label: "Статус",
          items: _ctx.statusFilterItems,
          "is-show-icon": false,
          onFilter: _ctx.onStatusFilter
        }, null, 8, ["items", "onFilter"])
      ]),
      (_ctx.isShowPartner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_UiDropdownFilter, {
              label: "Дата создания",
              "dropdown-default-label": "Без сортировки",
              items: _ctx.sortItems,
              "is-show-icon": false,
              onFilter: _ctx.onInsertOrder
            }, null, 8, ["items", "onFilter"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_UiDropdownFilter, {
              label: "Срок действия",
              "dropdown-default-label": "Без сортировки",
              items: _ctx.expiredFilterItems,
              "is-show-icon": false,
              onFilter: _ctx.onExpireOrder
            }, null, 8, ["items", "onFilter"])
          ]))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.notify(item) ? 'it__t it__t_notify' : 'it__t'),
        key: index
      }, [
        (_ctx.isShowPartner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.partner), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatChannel(item.sourceName, item.channel)), 1),
        _createElementVNode("div", {
          class: "it__t-body it__instance-detail",
          onClick: ($event: any) => (
					_ctx.onClickRedirect(
						'instance-detail',
						item.instance,
						item.channel
					)
				)
        }, _toDisplayString(item.instance), 9, _hoisted_12),
        _createElementVNode("div", _hoisted_13, _toDisplayString(item.token), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatPhoneNumber(item.phone)), 1),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_UiStatusIndicator, {
            value: item.status
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass({
					'it__t-body': true,
					'it__t-body_notify': _ctx.notify(item) && !_ctx.isShowPartner,
				})
        }, [
          (_ctx.isShowPartner)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.dataTimeFormat(item.insertStamp, true)), 1)
              ], 64))
            : (_ctx.hasExpirePaymentStamp(item.expirePaymentStamp))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" до " + _toDisplayString(_ctx.dataTimeFormat(item.expirePaymentStamp)), 1)
                ], 64))
              : _createCommentVNode("", true)
        ], 2)
      ], 2))
    }), 128))
  ], 4))
}